// import fetch from '../utils/fetch';
import fetch,{postFrom,getBlob} from '../utils/fetch';

// 查询商机下拉框数据获取
export function getSelectedData() {
    return fetch({
        method: 'GET',
        url: 'business/getConditions'
    })
}


export function getConditions() {
  return fetch({
    method: 'GET',
    url: 'business/getConditions'
  })
}

// 获取商机列表
export function enterpriselist(params) {
  return fetch({
    method: 'POST',
    url: 'business/enterprise/list',
    data:params
  })
}

// 获取商机列表
export function getList(params) {
  return fetch({
      method: 'POST',
      url: 'business/list',
      data:params
  })
}

// 获取查看商机详情
export function getDetail(businessFid) {
  return fetch({
      method: 'GET',
      url: 'business/getDetail',
      params:{
        businessFid
      }
  })
}

// 商机处理流转记录列表
export function getHandleList(businessFid) {
  return fetch({
    method: 'GET',
    url: 'business/listHandleResult',
    params: {
      businessFid
    }
  })
}

// 处理商机
export function handleBusiness(data) {
  return fetch({
      method: 'POST',
      url: 'business/saveBusinessHandle',
      data
  })
}

// 是否有约看商机
export function isHaveLookBusiness(data) {
  return fetch({
      method: 'POST',
      url: 'business/isHaveLookBusiness',
      data
  })
}

// 分配商机
export function allocateBusiness(businessInfo,zoFid,zoName) {
  return fetch({
    method: 'POST',
    url: 'business/allocateBusiness',
    data:{
      businessInfo,
      zoFid,
      zoName
    }
  })
}

// 新建商机
export function createBusiness(data) {
  return fetch({
    method: 'POST',
    url: 'business/createBusiness',
    data
  })
}

// 根据电话查询合同号 business/getContractCode
export function getContractCode(params) {
  return fetch({
    method: 'GET',
    url: 'business/getContractCode',
      params

  })
}

// 根据电话查询最新签约日合同号
export function getNewContractCode(params) {
  return fetch({
    method: 'GET',
    url: 'business/getNewContractCode',
    params

  })
}

// 查询修改商机权限 /business/allowHandleBusiness
export function allowHandleBusiness(businessFids) {
  return fetch({
    method: 'GET',
    url: 'business/allowHandleBusiness',
    params: {
      businessFids
    }
  })
}

//  导出商机
export function downloadBusinessList(data) {
  return getBlob({
    method: 'POST',
    url: 'business/downloadBusinessList',
    data
  })
}

// 商机列表数量查询
export function checkBusinessCount(data) {
  return fetch({
    method:'POST',
    url:'business/downloadBusinessListCount',
    data
  })
}

// 工作台获取商机数量
export function getBusinessNum(params) {
  return fetch({
    method: 'GET',
    url: 'business/getBusinessNum',
    params
  })
}

// 工作台待办数量
export function getNeedToDoNum(params) {
  return fetch({
    method: 'GET',
    url: 'business/getNeedToDoNum',
    params
  })
}

// 判断是否有查看录音的权限
export function getIsShowRecord() {
  return fetch({
    method: 'GET',
    url: 'business/getIsShowRecord'
  })
}

export function changeTakeLookZo(data) {
  return fetch({
    method: 'POST',
    url: '/business/changeTakeLookZo',
    data
  })
}


// 获取用户浏览记录
export function getBrowseHistory(customerUid,page,limit) {
  return fetch({
    method: 'GET',
    url: 'business/getCustomerProfileBrowse',
    params:{
      customerUid,
      page,
      limit
    }
  })
}

// 获取用户收藏记录
export function getCollectionHistory(customerUid,page,limit) {
  return fetch({
    method: 'GET',
    url: 'business/getCustomerProfileCollection',
    params:{
      customerUid,
      page,
      limit
    }
  })
}

// 获取历史合同
export function getContractHistory(customerUid) {
  return fetch({
    method: 'GET',
    url: 'business/getCustomerContractList',
    params:{
      customerUid
    }
  })
}

// 获取历史合同
export function getAllBusinessRecords(businessFid) {
  return fetch({
    method: 'GET',
    url: 'business/getAllBusinessRecordsByBusinessFid',
    params:{
      businessFid
    }
  })
}
//获取商机枚举
///business/getBusenessEnums
export function getBusinessEnums(params) {
  return fetch({
    method: 'GET',
    url: 'business/getBusinessEnums',
    params
  })
}
//getRegionByProjectFid

export function getRegionByProjectFid(params) {
// <<<<<<< HEAD
// =======
  return fetch({
    method: 'GET',
    url: 'business/getRegionByProjectFid',
    params
  })
}


//getAreaRegionByProjectFid
export function getAreaRegionByProjectFid(params) {
  return fetch({
    method: 'GET',
    url: 'business/getAreaRegionByProjectFid',
    params
  })
}

// 工作台获取有房提醒数量
export function getHouseRemindNum(params) {
  return fetch({
    method: 'GET',
    url: 'business/getHouseRemindNum',
    params
  })
}
///customerInfo/getRegionEnum
export function getRegionEnum(params) {
  return fetch({
    method: 'GET',
    url: 'customerInfo/getRegionEnum',
    params
  })
}
///customerInfo/getCustomerList
export function getCustomerList(data) {
  return fetch({
    method: 'POST',
    url: '/customerInfo/getCustomerList',
    data
  })
}
///customerInfo/getNationEnum
export function getNationEnum(params) {
  return fetch({
    method: 'GET',
    url: 'customerInfo/getNationEnum',
    params
  })
}

//customerInfo/getCityEnumByNationCode
export function getCityEnumByNationCode(params) {
  return fetch({
    method: 'GET',
    url: 'customerInfo/getCityEnumByNationCode',
    params
  })
}
//更新记录

export function updateCustomer(data) {
  return fetch({
    method: 'POST',
    url: 'customerInfo/updateCustomer',
    data
  })
}

///customerInfo/getCustomerPortrait

export function getCustomerPortrait(params) {
  return fetch({
    method: 'GET',
    url: 'customerInfo/getCustomerPortrait',
    params
  })
}
///customerInfo/getCustomerPortraitLog
export function getCustomerPortraitLog(params) {
  return fetch({
    method: 'GET',
    url: 'customerInfo/getCustomerPortraitLog',
    params
  })
}

export function getLast30DaysBusiness(params) {
  return fetch({
    method: 'GET',
    url: 'business/latest/sign',
    params
  })
}

//直播

export function liveList(params) {
  return fetch({
    method: 'GET',
    url: '/live/list',
    params
  })
}
